// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonQuillBox .ql-editor {
    min-height: 300px;
    max-height: 300px;
    overflow-y: auto;
    overflow-x: auto;
}

.commonQuillBox .ql-toolbar.ql-snow {
    border-color: var(--primary-border);
    text-align: start
}

.commonQuillBox .ql-container.ql-snow {
    border-color: var(--primary-border);
}

.commonQuillBox .ql-snow .ql-tooltip {
    top: 0 !important;
    left: 0 !important;
    margin-top: 0 !important;
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
}

.commonQuillBox .ql-snow .ql-tooltip::before,
.commonQuillBox .ql-snow .ql-tooltip a.ql-action::after,
.commonQuillBox .ql-snow .ql-tooltip a.ql-remove::before {
    margin: 0;
}

.commonQuillBox .ql-snow .ql-tooltip.ql-hidden {
    display: none !important;
}

.commonQuillBox .ql-container {
    border-radius: 0 0 8px 8px;
}

.commonQuillBox .ql-container,
.commonQuillBox .ql-toolbar.ql-snow {
    font-family: var(--font-family-base);
}

.commonQuillBox .ql-editor,
.ql-editor.frontend {
    text-align: start;
}

.commonQuillBox .ql-editor h2,
.commonQuillBox .ql-editor h3,
.commonQuillBox .ql-editor h4,
.commonQuillBox .ql-editor .ql-size-huge,
.commonQuillBox .ql-editor .ql-size-large,
.commonQuillBox .ql-editor p,
.commonQuillBox .ql-editor li,
.commonQuillBox .ql-editor .ql-size-small {
    line-height: normal;
    color: var(--primary-foreground);
}

.commonQuillBox .ql-snow .ql-editor h1,
.ql-editor.frontend h1 {
    font-size: 28px;
}

.commonQuillBox .ql-snow .ql-editor h2,
.ql-editor.frontend h2 {
    font-size: 26px;
}

.commonQuillBox .ql-snow .ql-editor h3,
.ql-editor.frontend h3 {
    font-size: 24px;
}

.commonQuillBox .ql-snow .ql-editor h4,
.ql-editor.frontend h4 {
    font-size: 22px;
}

.commonQuillBox .ql-snow .ql-editor .ql-size-huge,
.ql-editor.frontend .ql-size-huge {
    font-size: 20px;
}

.commonQuillBox .ql-snow .ql-editor .ql-size-large,
.ql-editor.frontend .ql-size-large {
    font-size: 18px;
}

.commonQuillBox .ql-snow .ql-editor p,
.commonQuillBox .ql-snow .ql-editor li,
.ql-editor.frontend p,
.ql-editor.frontend li {
    font-size: 16px;
}

.commonQuillBox .ql-snow .ql-editor .ql-size-small,
.ql-editor.frontend .ql-size-small {
    font-size: 14px;
}

.ql-editor.frontend {
    padding: 0;
    overflow: unset;
}

.commonQuillBox .ql-snow .ql-stroke {
    stroke: var(--primary-foreground);
}

.commonQuillBox .ql-snow .ql-picker {
    color: var(--primary-foreground);
}

.commonQuillBox .ql-snow .ql-fill {
    fill: var(--primary-foreground);
}

.commonQuillBox .ql-editor.ql-blank::before {
    color: rgb(255 254 254 / 60%);
}

.commonQuillBox .ql-snow .ql-picker-options {
    background-color: var(--background-secondary);
}

.commonQuillBox .ql-snow .ql-editor a,
.commonQuillBox .ql-snow .ql-editor a:hover,
.commonQuillBox .ql-snow .ql-editor a:focus,
.ql-editor.frontend a,
.ql-editor.frontend a:hover,
.ql-editor.frontend a:focus {
    color: var(--primary-link-foreground);
}

.commonQuillBox .ql-editor .ql-indent-1,
.ql-editor.frontend .ql-indent-1 {
    padding-left: 6px;
}

.commonQuillBox .ql-editor li.ql-indent-1,
.ql-editor.frontend li.ql-indent-1 {
    padding-left: 8px;
}

.commonQuillBox .ql-editor .ql-indent-2,
.ql-editor.frontend .ql-indent-2 {
    padding-left: 12px;
}

.commonQuillBox .ql-editor li.ql-indent-2,
.ql-editor.frontend li.ql-indent-2 {
    padding-left: 16px;
}

.commonQuillBox .ql-editor .ql-indent-3,
.ql-editor.frontend .ql-indent-3 {
    padding-left: 18px;
}

.commonQuillBox .ql-editor li.ql-indent-3,
.ql-editor.frontend li.ql-indent-3 {
    padding-left: 24px;
}

.commonQuillBox .ql-editor .ql-indent-4,
.ql-editor.frontend .ql-indent-4 {
    padding-left: 24px;
}

.commonQuillBox .ql-editor li.ql-indent-4,
.ql-editor.frontend li.ql-indent-4 {
    padding-left: 32px;
}

.commonQuillBox .ql-editor .ql-indent-5,
.ql-editor.frontend .ql-indent-5 {
    padding-left: 30px;
}

.commonQuillBox .ql-editor li.ql-indent-5,
.ql-editor.frontend li.ql-indent-5 {
    padding-left: 40px;
}

.commonQuillBox .ql-editor .ql-indent-6,
.ql-editor.frontend .ql-indent-6 {
    padding-left: 36px;
}

.commonQuillBox .ql-editor li.ql-indent-6,
.ql-editor.frontend li.ql-indent-6 {
    padding-left: 48px;
}

.commonQuillBox .ql-editor .ql-indent-7,
.ql-editor.frontend .ql-indent-7 {
    padding-left: 42px;
}

.commonQuillBox .ql-editor li.ql-indent-7,
.ql-editor.frontend li.ql-indent-7 {
    padding-left: 56px;
}

.commonQuillBox .ql-editor .ql-indent-8,
.ql-editor.frontend .ql-indent-8 {
    padding-left: 48px;
}

.commonQuillBox .ql-editor li.ql-indent-8,
.ql-editor.frontend li.ql-indent-8 {
    padding-left: 64px;
}

.commonQuillBox .ql-editor .ql-indent-9,
.ql-editor.frontend .ql-indent-9 {
    padding-left: 54px;
}

.commonQuillBox .ql-editor li.ql-indent-9,
.ql-editor.frontend li.ql-indent-9 {
    padding-left: 72px;
}

.ql-editor.frontend img {
    width: 100%;
    max-width: 100%;
    margin-bottom: 0;
}

/* rtl */

.rtl .commonQuillBox .ql-snow .ql-tooltip {
    left: unset !important;
    right: 0 !important;
}

.rtl .ql-editor.frontend {
    padding-right: 2px;
}

.rtl .commonQuillBox .ql-editor li>span::before,
.rtl .ql-editor.frontend li>span::before {
    margin-left: 0.3em;
    margin-right: -1.5em;
    text-align: left;
}

.rtl .commonQuillBox .ql-toolbar.ql-snow .ql-formats {
    margin-right: unset;
    margin-left: 15px;
}

.rtl .commonQuillBox .ql-editor ol,
.rtl .commonQuillBox .ql-editor ul,
.rtl .ql-editor.frontend ol,
.rtl .ql-editor.frontend ul {
    padding-left: unset;
    padding-right: 1.5em;
}

.rtl .commonQuillBox .ql-editor ol li,
.rtl .commonQuillBox .ql-editor ul li,
.rtl .ql-editor.frontend ol li,
.rtl .ql-editor.frontend ul li {
    padding-left: unset;
    padding-right: 1.5em;
}

.rtl .commonQuillBox .ql-editor .ql-indent-1,
.rtl .ql-editor.frontend .ql-indent-1 {
    padding-left: unset;
    padding-right: 6px;
}

.rtl .commonQuillBox .ql-editor li.ql-indent-1,
.rtl .ql-editor.frontend li.ql-indent-1 {
    padding-left: unset;
    padding-right: 8px;
}

.rtl .commonQuillBox .ql-editor .ql-indent-2,
.rtl .ql-editor.frontend .ql-indent-1 {
    padding-left: unset;
    padding-right: 12px;
}

.rtl .commonQuillBox .ql-editor li.ql-indent-2,
.rtl .ql-editor.frontend li.ql-indent-2 {
    padding-left: unset;
    padding-right: 16px;
}

.rtl .commonQuillBox .ql-editor .ql-indent-3,
.rtl .ql-editor.frontend .ql-indent-1 {
    padding-left: unset;
    padding-right: 18px;
}

.rtl .commonQuillBox .ql-editor li.ql-indent-3,
.rtl .ql-editor.frontend li.ql-indent-3 {
    padding-left: unset;
    padding-right: 24px;
}

.rtl .commonQuillBox .ql-editor .ql-indent-4,
.rtl .ql-editor.frontend .ql-indent-1 {
    padding-left: unset;
    padding-right: 24px;
}

.rtl .commonQuillBox .ql-editor li.ql-indent-4,
.rtl .ql-editor.frontend li.ql-indent-4 {
    padding-left: unset;
    padding-right: 32px;
}

.rtl .commonQuillBox .ql-editor .ql-indent-5,
.rtl .ql-editor.frontend .ql-indent-5 {
    padding-left: unset;
    padding-right: 30px;
}

.rtl .commonQuillBox .ql-editor li.ql-indent-5,
.rtl .ql-editor.frontend li.ql-indent-5 {
    padding-left: unset;
    padding-right: 40px;
}

.rtl .commonQuillBox .ql-editor .ql-indent-6,
.rtl .ql-editor.frontend .ql-indent-6 {
    padding-left: unset;
    padding-right: 36px;
}

.rtl .commonQuillBox .ql-editor li.ql-indent-6,
.rtl .ql-editor.frontend li.ql-indent-6 {
    padding-left: unset;
    padding-right: 48px;
}

.rtl .commonQuillBox .ql-editor .ql-indent-7,
.rtl .ql-editor.frontend .ql-indent-7 {
    padding-left: unset;
    padding-right: 42px;
}

.rtl .commonQuillBox .ql-editor li.ql-indent-7,
.rtl .ql-editor.frontend li.ql-indent-7 {
    padding-left: unset;
    padding-right: 56px;
}

.rtl .commonQuillBox .ql-editor .ql-indent-8,
.rtl .ql-editor.frontend .ql-indent-8 {
    padding-left: unset;
    padding-right: 48px;
}

.rtl .commonQuillBox .ql-editor li.ql-indent-8,
.rtl .ql-editor.frontend li.ql-indent-8 {
    padding-left: unset;
    padding-right: 64px;
}

.rtl .commonQuillBox .ql-editor .ql-indent-9,
.rtl .ql-editor.frontend .ql-indent-9 {
    padding-left: unset;
    padding-right: 54px;
}

.rtl .commonQuillBox .ql-editor li.ql-indent-9,
.rtl .ql-editor.frontend li.ql-indent-9 {
    padding-left: unset;
    padding-right: 72px;
}

.rtl .commonQuillBox .ql-editor blockquote,
.rtl .ql-editor.frontend blockquote {
    padding-left: unset;
    padding-right: 16px;
    border-left: unset;
    border-right: 4px solid #ccc;
}

.rtl .commonQuillBox .ql-snow .ql-picker-label,
.rtl .ql-editor.frontend .ql-picker-label {
    padding-left: 2px;
    padding-right: 8px;
    text-align: left;
}

/* precaution notification popup quill start */
.safetyMeasuresModalContentBox .ql-editor.frontend h2 {
    font-size: 18px;
    line-height: 28px;
    color: var(--primary-foreground);
    text-align: start;
}

.safetyMeasuresModalContentBox .ql-editor.frontend h1 {
    font-size: 20px;
    line-height: 30px;
    color: var(--primary-foreground);
    text-align: start;
}

.safetyMeasuresModalContentBox .ql-editor.frontend h1,
.safetyMeasuresModalContentBox .ql-editor.frontend h2 {
    font-weight: 600;
    margin-bottom: 6px;
    margin-top: 0;
}

.safetyMeasuresModalContentBox .ql-editor.frontend p {
    font-size: 14px;
    line-height: 24px;
    font-weight: 400;
    color: var(--primary-foreground);
    text-align: start;
}

.safetyMeasuresModalContentBox .ql-editor.frontend p {
    margin-bottom: 6px;
}

.safetyMeasuresModalContentBox .ql-editor.frontend ul,
.safetyMeasuresModalContentBox .ql-editor.frontend ol,
.safetyMeasuresModalContentBox .ql-editor.frontend menu {
    margin-bottom: 18px;
    padding-left: 0;
}

.safetyMeasuresModalContentBox .ql-editor.frontend li,
.safetyMeasuresModalContentBox .ql-editor.frontend blockquote {
    margin-bottom: 6px;
    font-size: 14px;
    line-height: 24px;
    font-weight: 400;
    color: var(--primary-foreground);
    text-align: start;
}

.safetyMeasuresModalContentBox .ql-editor.frontend .ql-size-large,
.safetyMeasuresModalContentBox .ql-editor.frontend .ql-size-huge {
    font-size: 16px;
    line-height: 26px;
}

.safetyMeasuresModalContentBox .ql-editor.frontend a,
.safetyMeasuresModalContentBox .ql-editor.frontend a:hover,
.safetyMeasuresModalContentBox .ql-editor.frontend a:focus {
    color: var(--primary-link-foreground) !important;
    text-decoration: unset;
    cursor: pointer;
}

.rtl .safetyMeasuresModalContentBox .ql-editor.frontend ul,
.rtl .safetyMeasuresModalContentBox .ql-editor.frontend ol,
.rtl .safetyMeasuresModalContentBox .ql-editor.frontend menu {
    padding-left: 0;
    padding-right: 0;
}

/* precaution notification popup quill end */`, "",{"version":3,"sources":["webpack://./src/styles/customQuillEditor.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC;AACJ;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,wBAAwB;IACxB,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;;;IAGI,SAAS;AACb;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;;;;;;;IAQI,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;;;IAII,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6CAA6C;AACjD;;AAEA;;;;;;IAMI,qCAAqC;AACzC;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA,QAAQ;;AAER;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;;;;IAII,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;;;;IAII,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;;IAEI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,8CAA8C;AAC9C;IACI,eAAe;IACf,iBAAiB;IACjB,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;IAGI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;;;IAGI,gDAAgD;IAChD,sBAAsB;IACtB,eAAe;AACnB;;AAEA;;;IAGI,eAAe;IACf,gBAAgB;AACpB;;AAEA,4CAA4C","sourcesContent":[".commonQuillBox .ql-editor {\n    min-height: 300px;\n    max-height: 300px;\n    overflow-y: auto;\n    overflow-x: auto;\n}\n\n.commonQuillBox .ql-toolbar.ql-snow {\n    border-color: var(--primary-border);\n    text-align: start\n}\n\n.commonQuillBox .ql-container.ql-snow {\n    border-color: var(--primary-border);\n}\n\n.commonQuillBox .ql-snow .ql-tooltip {\n    top: 0 !important;\n    left: 0 !important;\n    margin-top: 0 !important;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 5px;\n}\n\n.commonQuillBox .ql-snow .ql-tooltip::before,\n.commonQuillBox .ql-snow .ql-tooltip a.ql-action::after,\n.commonQuillBox .ql-snow .ql-tooltip a.ql-remove::before {\n    margin: 0;\n}\n\n.commonQuillBox .ql-snow .ql-tooltip.ql-hidden {\n    display: none !important;\n}\n\n.commonQuillBox .ql-container {\n    border-radius: 0 0 8px 8px;\n}\n\n.commonQuillBox .ql-container,\n.commonQuillBox .ql-toolbar.ql-snow {\n    font-family: var(--font-family-base);\n}\n\n.commonQuillBox .ql-editor,\n.ql-editor.frontend {\n    text-align: start;\n}\n\n.commonQuillBox .ql-editor h2,\n.commonQuillBox .ql-editor h3,\n.commonQuillBox .ql-editor h4,\n.commonQuillBox .ql-editor .ql-size-huge,\n.commonQuillBox .ql-editor .ql-size-large,\n.commonQuillBox .ql-editor p,\n.commonQuillBox .ql-editor li,\n.commonQuillBox .ql-editor .ql-size-small {\n    line-height: normal;\n    color: var(--primary-foreground);\n}\n\n.commonQuillBox .ql-snow .ql-editor h1,\n.ql-editor.frontend h1 {\n    font-size: 28px;\n}\n\n.commonQuillBox .ql-snow .ql-editor h2,\n.ql-editor.frontend h2 {\n    font-size: 26px;\n}\n\n.commonQuillBox .ql-snow .ql-editor h3,\n.ql-editor.frontend h3 {\n    font-size: 24px;\n}\n\n.commonQuillBox .ql-snow .ql-editor h4,\n.ql-editor.frontend h4 {\n    font-size: 22px;\n}\n\n.commonQuillBox .ql-snow .ql-editor .ql-size-huge,\n.ql-editor.frontend .ql-size-huge {\n    font-size: 20px;\n}\n\n.commonQuillBox .ql-snow .ql-editor .ql-size-large,\n.ql-editor.frontend .ql-size-large {\n    font-size: 18px;\n}\n\n.commonQuillBox .ql-snow .ql-editor p,\n.commonQuillBox .ql-snow .ql-editor li,\n.ql-editor.frontend p,\n.ql-editor.frontend li {\n    font-size: 16px;\n}\n\n.commonQuillBox .ql-snow .ql-editor .ql-size-small,\n.ql-editor.frontend .ql-size-small {\n    font-size: 14px;\n}\n\n.ql-editor.frontend {\n    padding: 0;\n    overflow: unset;\n}\n\n.commonQuillBox .ql-snow .ql-stroke {\n    stroke: var(--primary-foreground);\n}\n\n.commonQuillBox .ql-snow .ql-picker {\n    color: var(--primary-foreground);\n}\n\n.commonQuillBox .ql-snow .ql-fill {\n    fill: var(--primary-foreground);\n}\n\n.commonQuillBox .ql-editor.ql-blank::before {\n    color: rgb(255 254 254 / 60%);\n}\n\n.commonQuillBox .ql-snow .ql-picker-options {\n    background-color: var(--background-secondary);\n}\n\n.commonQuillBox .ql-snow .ql-editor a,\n.commonQuillBox .ql-snow .ql-editor a:hover,\n.commonQuillBox .ql-snow .ql-editor a:focus,\n.ql-editor.frontend a,\n.ql-editor.frontend a:hover,\n.ql-editor.frontend a:focus {\n    color: var(--primary-link-foreground);\n}\n\n.commonQuillBox .ql-editor .ql-indent-1,\n.ql-editor.frontend .ql-indent-1 {\n    padding-left: 6px;\n}\n\n.commonQuillBox .ql-editor li.ql-indent-1,\n.ql-editor.frontend li.ql-indent-1 {\n    padding-left: 8px;\n}\n\n.commonQuillBox .ql-editor .ql-indent-2,\n.ql-editor.frontend .ql-indent-2 {\n    padding-left: 12px;\n}\n\n.commonQuillBox .ql-editor li.ql-indent-2,\n.ql-editor.frontend li.ql-indent-2 {\n    padding-left: 16px;\n}\n\n.commonQuillBox .ql-editor .ql-indent-3,\n.ql-editor.frontend .ql-indent-3 {\n    padding-left: 18px;\n}\n\n.commonQuillBox .ql-editor li.ql-indent-3,\n.ql-editor.frontend li.ql-indent-3 {\n    padding-left: 24px;\n}\n\n.commonQuillBox .ql-editor .ql-indent-4,\n.ql-editor.frontend .ql-indent-4 {\n    padding-left: 24px;\n}\n\n.commonQuillBox .ql-editor li.ql-indent-4,\n.ql-editor.frontend li.ql-indent-4 {\n    padding-left: 32px;\n}\n\n.commonQuillBox .ql-editor .ql-indent-5,\n.ql-editor.frontend .ql-indent-5 {\n    padding-left: 30px;\n}\n\n.commonQuillBox .ql-editor li.ql-indent-5,\n.ql-editor.frontend li.ql-indent-5 {\n    padding-left: 40px;\n}\n\n.commonQuillBox .ql-editor .ql-indent-6,\n.ql-editor.frontend .ql-indent-6 {\n    padding-left: 36px;\n}\n\n.commonQuillBox .ql-editor li.ql-indent-6,\n.ql-editor.frontend li.ql-indent-6 {\n    padding-left: 48px;\n}\n\n.commonQuillBox .ql-editor .ql-indent-7,\n.ql-editor.frontend .ql-indent-7 {\n    padding-left: 42px;\n}\n\n.commonQuillBox .ql-editor li.ql-indent-7,\n.ql-editor.frontend li.ql-indent-7 {\n    padding-left: 56px;\n}\n\n.commonQuillBox .ql-editor .ql-indent-8,\n.ql-editor.frontend .ql-indent-8 {\n    padding-left: 48px;\n}\n\n.commonQuillBox .ql-editor li.ql-indent-8,\n.ql-editor.frontend li.ql-indent-8 {\n    padding-left: 64px;\n}\n\n.commonQuillBox .ql-editor .ql-indent-9,\n.ql-editor.frontend .ql-indent-9 {\n    padding-left: 54px;\n}\n\n.commonQuillBox .ql-editor li.ql-indent-9,\n.ql-editor.frontend li.ql-indent-9 {\n    padding-left: 72px;\n}\n\n.ql-editor.frontend img {\n    width: 100%;\n    max-width: 100%;\n    margin-bottom: 0;\n}\n\n/* rtl */\n\n.rtl .commonQuillBox .ql-snow .ql-tooltip {\n    left: unset !important;\n    right: 0 !important;\n}\n\n.rtl .ql-editor.frontend {\n    padding-right: 2px;\n}\n\n.rtl .commonQuillBox .ql-editor li>span::before,\n.rtl .ql-editor.frontend li>span::before {\n    margin-left: 0.3em;\n    margin-right: -1.5em;\n    text-align: left;\n}\n\n.rtl .commonQuillBox .ql-toolbar.ql-snow .ql-formats {\n    margin-right: unset;\n    margin-left: 15px;\n}\n\n.rtl .commonQuillBox .ql-editor ol,\n.rtl .commonQuillBox .ql-editor ul,\n.rtl .ql-editor.frontend ol,\n.rtl .ql-editor.frontend ul {\n    padding-left: unset;\n    padding-right: 1.5em;\n}\n\n.rtl .commonQuillBox .ql-editor ol li,\n.rtl .commonQuillBox .ql-editor ul li,\n.rtl .ql-editor.frontend ol li,\n.rtl .ql-editor.frontend ul li {\n    padding-left: unset;\n    padding-right: 1.5em;\n}\n\n.rtl .commonQuillBox .ql-editor .ql-indent-1,\n.rtl .ql-editor.frontend .ql-indent-1 {\n    padding-left: unset;\n    padding-right: 6px;\n}\n\n.rtl .commonQuillBox .ql-editor li.ql-indent-1,\n.rtl .ql-editor.frontend li.ql-indent-1 {\n    padding-left: unset;\n    padding-right: 8px;\n}\n\n.rtl .commonQuillBox .ql-editor .ql-indent-2,\n.rtl .ql-editor.frontend .ql-indent-1 {\n    padding-left: unset;\n    padding-right: 12px;\n}\n\n.rtl .commonQuillBox .ql-editor li.ql-indent-2,\n.rtl .ql-editor.frontend li.ql-indent-2 {\n    padding-left: unset;\n    padding-right: 16px;\n}\n\n.rtl .commonQuillBox .ql-editor .ql-indent-3,\n.rtl .ql-editor.frontend .ql-indent-1 {\n    padding-left: unset;\n    padding-right: 18px;\n}\n\n.rtl .commonQuillBox .ql-editor li.ql-indent-3,\n.rtl .ql-editor.frontend li.ql-indent-3 {\n    padding-left: unset;\n    padding-right: 24px;\n}\n\n.rtl .commonQuillBox .ql-editor .ql-indent-4,\n.rtl .ql-editor.frontend .ql-indent-1 {\n    padding-left: unset;\n    padding-right: 24px;\n}\n\n.rtl .commonQuillBox .ql-editor li.ql-indent-4,\n.rtl .ql-editor.frontend li.ql-indent-4 {\n    padding-left: unset;\n    padding-right: 32px;\n}\n\n.rtl .commonQuillBox .ql-editor .ql-indent-5,\n.rtl .ql-editor.frontend .ql-indent-5 {\n    padding-left: unset;\n    padding-right: 30px;\n}\n\n.rtl .commonQuillBox .ql-editor li.ql-indent-5,\n.rtl .ql-editor.frontend li.ql-indent-5 {\n    padding-left: unset;\n    padding-right: 40px;\n}\n\n.rtl .commonQuillBox .ql-editor .ql-indent-6,\n.rtl .ql-editor.frontend .ql-indent-6 {\n    padding-left: unset;\n    padding-right: 36px;\n}\n\n.rtl .commonQuillBox .ql-editor li.ql-indent-6,\n.rtl .ql-editor.frontend li.ql-indent-6 {\n    padding-left: unset;\n    padding-right: 48px;\n}\n\n.rtl .commonQuillBox .ql-editor .ql-indent-7,\n.rtl .ql-editor.frontend .ql-indent-7 {\n    padding-left: unset;\n    padding-right: 42px;\n}\n\n.rtl .commonQuillBox .ql-editor li.ql-indent-7,\n.rtl .ql-editor.frontend li.ql-indent-7 {\n    padding-left: unset;\n    padding-right: 56px;\n}\n\n.rtl .commonQuillBox .ql-editor .ql-indent-8,\n.rtl .ql-editor.frontend .ql-indent-8 {\n    padding-left: unset;\n    padding-right: 48px;\n}\n\n.rtl .commonQuillBox .ql-editor li.ql-indent-8,\n.rtl .ql-editor.frontend li.ql-indent-8 {\n    padding-left: unset;\n    padding-right: 64px;\n}\n\n.rtl .commonQuillBox .ql-editor .ql-indent-9,\n.rtl .ql-editor.frontend .ql-indent-9 {\n    padding-left: unset;\n    padding-right: 54px;\n}\n\n.rtl .commonQuillBox .ql-editor li.ql-indent-9,\n.rtl .ql-editor.frontend li.ql-indent-9 {\n    padding-left: unset;\n    padding-right: 72px;\n}\n\n.rtl .commonQuillBox .ql-editor blockquote,\n.rtl .ql-editor.frontend blockquote {\n    padding-left: unset;\n    padding-right: 16px;\n    border-left: unset;\n    border-right: 4px solid #ccc;\n}\n\n.rtl .commonQuillBox .ql-snow .ql-picker-label,\n.rtl .ql-editor.frontend .ql-picker-label {\n    padding-left: 2px;\n    padding-right: 8px;\n    text-align: left;\n}\n\n/* precaution notification popup quill start */\n.safetyMeasuresModalContentBox .ql-editor.frontend h2 {\n    font-size: 18px;\n    line-height: 28px;\n    color: var(--primary-foreground);\n    text-align: start;\n}\n\n.safetyMeasuresModalContentBox .ql-editor.frontend h1 {\n    font-size: 20px;\n    line-height: 30px;\n    color: var(--primary-foreground);\n    text-align: start;\n}\n\n.safetyMeasuresModalContentBox .ql-editor.frontend h1,\n.safetyMeasuresModalContentBox .ql-editor.frontend h2 {\n    font-weight: 600;\n    margin-bottom: 6px;\n    margin-top: 0;\n}\n\n.safetyMeasuresModalContentBox .ql-editor.frontend p {\n    font-size: 14px;\n    line-height: 24px;\n    font-weight: 400;\n    color: var(--primary-foreground);\n    text-align: start;\n}\n\n.safetyMeasuresModalContentBox .ql-editor.frontend p {\n    margin-bottom: 6px;\n}\n\n.safetyMeasuresModalContentBox .ql-editor.frontend ul,\n.safetyMeasuresModalContentBox .ql-editor.frontend ol,\n.safetyMeasuresModalContentBox .ql-editor.frontend menu {\n    margin-bottom: 18px;\n    padding-left: 0;\n}\n\n.safetyMeasuresModalContentBox .ql-editor.frontend li,\n.safetyMeasuresModalContentBox .ql-editor.frontend blockquote {\n    margin-bottom: 6px;\n    font-size: 14px;\n    line-height: 24px;\n    font-weight: 400;\n    color: var(--primary-foreground);\n    text-align: start;\n}\n\n.safetyMeasuresModalContentBox .ql-editor.frontend .ql-size-large,\n.safetyMeasuresModalContentBox .ql-editor.frontend .ql-size-huge {\n    font-size: 16px;\n    line-height: 26px;\n}\n\n.safetyMeasuresModalContentBox .ql-editor.frontend a,\n.safetyMeasuresModalContentBox .ql-editor.frontend a:hover,\n.safetyMeasuresModalContentBox .ql-editor.frontend a:focus {\n    color: var(--primary-link-foreground) !important;\n    text-decoration: unset;\n    cursor: pointer;\n}\n\n.rtl .safetyMeasuresModalContentBox .ql-editor.frontend ul,\n.rtl .safetyMeasuresModalContentBox .ql-editor.frontend ol,\n.rtl .safetyMeasuresModalContentBox .ql-editor.frontend menu {\n    padding-left: 0;\n    padding-right: 0;\n}\n\n/* precaution notification popup quill end */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
